import type { ObjectMetadata } from '@olytic/foundation';

import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asCheck, asDateTime, asLabel, column, createdByField, field, lastModifiedByField, type Row, related, text } from './kit';

const def = OBJECT_DEFS['price-grids'];

/** A Price Grid: a fixed menu of prices by Company Size, or by Company Size and Quantity. Rationale: price-grids.md. */
export const priceGrids: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Price Grid',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('name', 'Name'),
    field('prices_by', 'Pricing', { format: asLabel }),
    field('quantity_label', 'Quantity Label'),
    field('dimensions', 'Dimensions'),
    field('active', 'Active', { format: asCheck }),
    field('description', 'Description', { wide: true }),
    field('created_at', 'Created', { format: asDateTime }),
    field('updated_at', 'Last Modified', { format: asDateTime }),
    createdByField(),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['name', 'prices_by', 'quantity_label', 'dimensions', 'active'] },
    { key: 'description', label: 'Description', fields: ['description'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_at', 'created_by_name', 'updated_at', 'last_modified_by_name'] },
  ],
  // The cells are edited as one grid under the details (PriceGridCellsEditor).
  related: [
    related('prices', 'Prices Using It', 'prices', [
      column('name', 'Price', { primary: true }),
      column('product_name', 'Product'),
      column('selling_model', 'Selling Model'),
    ]),
  ],
  titleOf: (row) => text(row.name),
  searchKeys: ['name'],
};
